import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DurationModule } from '@portal-core/general/pipes/duration/duration.module';
import { PublicationProgressBarComponent } from './publication-progress-bar.component';

@NgModule({
  declarations: [
    PublicationProgressBarComponent
  ],
  imports: [
    CommonModule,
    DurationModule,
    MatProgressBarModule
  ],
  exports: [
    PublicationProgressBarComponent
  ]
})
export class PublicationProgressBarModule { }
